import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "swiper-included__card" }
const _hoisted_3 = { class: "swiper-included__title" }
const _hoisted_4 = {
  key: 0,
  class: "swiper-included__price"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "swiper-included__description" }

import { ref } from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import TitleDefault from "@/components/TitleDefault.vue";

import { WhatIncluded } from "@/types/pages/index/what-included";


export default /*#__PURE__*/_defineComponent({
  __name: 'WhatsIncluded',
  setup(__props) {

const dataIncluded = ref<WhatIncluded[]>([
    {
        title: 'АЗС Газпромнефть',
        image: 5,
        description: "Повышенные бонусы в программе лояльности",
    },
    {
        title: 'Wink',
        price: 199,
        image: 2,
        description: "Бесплатный доступ к онлайн-кинотеатру",
    },
    {
        title: 'OZON',
        price: 199,
        image: 4,
        description: "Преимущества OZON Premium",
    },
    {
        title: 'Сервис “Пакет”',
        price: 199,
        image: 3,
        description: "Кешбэк в Пятерочке и Перекрестке",
    },
    {
        title: 'Premier',
        price: 299,
        image: 1,
        description: "Фильмы и сериалы без доплат",
    },
    {
        title: 'Лента',
        image: 6,
        description: "Скидка 13% на \n" +
            "5 покупок в месяц",
    },
    {
        title: 'Лента онлайн',
        image: 7,
        description: "Скидка 15% на \n" +
            "3 заказа в месяц",
    },
    {
        title: 'Газпромбанк мобайл',
        image: 8,
        description: "Скидка 30% на мобильную связь",
    },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleDefault, {
      class: "home-menu__title",
      title: "Что включено"
    }),
    _createVNode(_unref(Swiper), {
      "space-between": 10,
      loop: true,
      class: "swiper-included",
      "slides-per-view": "auto"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataIncluded.value, (item, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(item.title), 1),
                (item.price)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item.price) + " ₽ ", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("img", {
                  src: `img/pages/index/what-included/${item.image}.png`,
                  class: "swiper-included__img",
                  alt: "Логотип, все включено"
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("p", _hoisted_6, _toDisplayString(item.description), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})